import { LIFE_CONTROL_OPTIONS } from '@/pages/Onboarding/options/LifeControl/LIFE_CONTROL_OPTIONS';
import { LifeControlOptionIdType } from '@/pages/Onboarding/options/LifeControl/types';

const DEFAULT_ID: LifeControlOptionIdType = 'always_in_control';
const DEFAULT_TITLE = LIFE_CONTROL_OPTIONS[0].title;

export const getLifeControlIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): LifeControlOptionIdType | null => {
  const id = LIFE_CONTROL_OPTIONS.find((option) => option.title === title)?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT_ID;
  }

  return null;
};

export const getLifeControlTitleById = (
  id: LifeControlOptionIdType | null | undefined,
  withDefault = false,
): string | null => {
  const title = LIFE_CONTROL_OPTIONS.find((option) => option.id === id)?.title;

  if (title) {
    return title;
  }

  if (withDefault) {
    return DEFAULT_TITLE;
  }

  return null;
};
